import MomentUtils from "@date-io/moment";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip
} from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import DeleteIcon from "@material-ui/icons/Delete";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ShareIcon from "@material-ui/icons/OpenInNew";
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import { memo, useEffect, useMemo, useRef, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import pinIconBlack from "../../assets/icons/pin-icon-black.png";
import pinIconRed from "../../assets/icons/pin-icon-red.png";
import { handleKeyDown } from "../../common/common";
import { fuelPriceOptions, vesselTableHeading } from "../../constants";
import { saveCalculatedCostResult } from "../../containers/User/Calculator/actions";
import CalculatorMain from "../../containers/User/Calculator/CalculatorMain";
import { getComparator, stableSort } from "../../utils";
import CustomAddModal from "../Common/CustomAddModal";
import ConfirmModal from "../Common/CustomConfirmModal";
import CustomShowModal from "../Common/CustomShowModal";
import AddFleetModal from "./AddCalculatorFleet/AddFleetTabView";
import DailyExpensesModal from "./DailyExpensesModal";
import SaveVesselLabel from "./SaveVesselLabel";
import SplitHireModal from "./SplitHireModal";
function VesselSelection(props) {
  const {
    disableEdit = false,
    selectedQuery = {},
    calculatorData = {},
    setCalculatorData = () => { },
    selectedVessels = [],
    onChangeFleetRowSelect = () => { },
    onDeleteFleet = () => { },
    onClickAddFleet = () => { },
    addFleetModal = false,
    addFleetsArray = [],
    setAddFleetsArray = () => { },
    onChangeNewFleetsValue = () => { },
    setLoader = () => { },
    loader = false,
    setAddFleetModal = () => { },
    sendCalculationRequest = () => { },
    setSelectedVessels = () => { },
    splitHireModal = false,
    setSplitHireModal = () => { },
    selectedSplitHire = {},
    setSelectedSplitHire = () => { },
    openSplitHireModal = () => { },
    onFetchPortOperationDistance = () => { },
    getInitalQueryAndFleetData = () => { },
    initialFleetList = [],

    onChangeSelectedVessel = () => { },
    fleetCheckbox = () => { },
    setFleetCheckbox = () => { },

    setMarginModal = () => { },
    syncBunker = () => { },
    setSyncBunker = () => { },
    setSupplyModal = () => { },
    onChangeSyncBunker = () => { },
    isOverride = () => { },
    cargoTabs = null,

    calculationErrors = {},

    marginModal,
    onChangePortOperations,
    onAddOperations,
    onDeleteOperations,
    supplyModal,
    fetchPortDistance,
    openAddOperation,
    setOpenAddOperation,
    setOpenAddOperationindex,
    onChangePortCanalInQueryState,
    setIsOverride,
    hideOrder,
    setHideOrder,
    hideCalculator,
    getCurrentResult,
    isFromCargoAnalysis = false,
    setPdfData = () => { },
    onChangeChartValue = () => { },
    setExpandedRows = () => { },
    expandedRows,
    showExpensesModal,
    setShowExpensesModal = () => { },
    onReorder = null,
    onPortChange = null,
  } = props;
  const {
    fleetList = [],
    portOperation = [],
    clientQuery = {},
  } = calculatorData || {};
  const { deliveryTerms = "", tcAdcom = "", _id: queryid } = clientQuery || {};
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("tceq");
  const [showConfrim, setShowConfrim] = useState(false);
  const [referenceCandidate, setReferenceCandidate] = useState(null);
  const [data, setData] = useState({});
  const [deleteId, setDeleteId] = useState("");
  const [saveModal, setSaveModal] = useState(false);
  const [selectedVessel, setSelectedVessel] = useState(null);
  const [saveLabel, setSaveLabel] = useState("");
  const [saveLabelError, setSaveLabelError] = useState(false);
  const history = useHistory();
  // const [expandedRows, setExpandedRows] = useState({}); // Track expanded rows
  const onChangeHandler = (id, name, value) => {
    const findIndex = fleetList.findIndex((item) => item._id === id);
    fleetList[findIndex][name] = value;

    setCalculatorData({
      ...calculatorData,
      fleetList,
    });
    if (id === selectedVessels._id) {
      setSelectedVessels({ ...selectedVessels, [name]: value });
    }
  };

  const onChangeSplitHire = (index, e, isDelete = false) => {
    let splitHire =
      (selectedSplitHire &&
        selectedSplitHire.splitHire &&
        JSON.parse(selectedSplitHire.splitHire)) ||
      [];
    if (isDelete) splitHire.splice(index, 1);
    else {
      const { name = "", value = "" } = e.target;
      splitHire[index][name] = Number(value);
    }
    const udpatedSelectedSplitHire = {
      ...selectedSplitHire,
      splitHire: JSON.stringify(splitHire),
    };
    setSelectedSplitHire(udpatedSelectedSplitHire);

    setCalculatorData({
      ...calculatorData,
      fleetList: calculatorData.fleetList.map((item) => {
        if (item._id === udpatedSelectedSplitHire._id) {
          return udpatedSelectedSplitHire;
        }
        return item;
      }),
    });
    if (udpatedSelectedSplitHire._id === selectedVessels._id)
      setSelectedVessels(udpatedSelectedSplitHire);
  };

  const addNewSplitHire = () => {
    let splitHire =
      (selectedSplitHire &&
        selectedSplitHire.splitHire &&
        JSON.parse(selectedSplitHire.splitHire)) ||
      [];
    if (!!splitHire.find((item) => item.NoDays === 0)) return;
    splitHire.push({ NoDays: 0, applied: 0, disable: false, hireRate: 0 });
    setSelectedSplitHire({
      ...selectedSplitHire,
      splitHire: JSON.stringify(splitHire),
    });
  };

  const onClickReferencePin = (fleet) => {
    setReferenceCandidate(fleet);
  };

  const onConfirmReferencePin = () => {
    if (!referenceCandidate) return;
    const markAsReference = !referenceCandidate.isReferenceVessel;
    const updatedData = {
      ...calculatorData,
      fleetList: calculatorData.fleetList.map((item) => ({
        ...item,
        isReferenceVessel: markAsReference && item._id === referenceCandidate._id,
      })),
    };
    setCalculatorData(updatedData);
    setReferenceCandidate(null);
    sendCalculationRequest({ ...updatedData, autoSave: false });
  };

  const onClickDeleleButton = () => {
    onDeleteFleet(deleteId);
    setShowConfrim(false);
    setDeleteId("");
  };

  // const getArrivalTimeOfFirstLoading = useMemo(() => {
  //     let time = ''
  //     for (let i = 0; i < portOperation.length; i++) {
  //         if (portOperation[i].operation === "Loading") {
  //             time = portOperation[i].arrivalTime
  //             break;
  //         }
  //     }
  //     return time
  // }, [portOperation])

  const onClickRowChange = (vessel) => {
    // onFetchPortOperationDistance()
    onChangeFleetRowSelect(vessel, null, true);
  };

  const onChangeClientQuery = (e) => {
    const { name = "", value = "" } = e.target || {};
    setCalculatorData({
      ...calculatorData,
      clientQuery: {
        ...clientQuery,
        [name]: value,
      },
    });
  };

  const onClickSaveFleet = (id, saveLabel = "", vessel) => {
    onChangeFleetRowSelect(vessel, null, true);
    setSelectedVessel(id);
    setSaveLabel(saveLabel);
    setSaveLabelError(false);
    setSaveModal(true);
  };

  const onCloseSaveFleet = () => {
    setSaveModal(false);
    setSelectedVessel(null);
    setSaveLabel("");
    setSaveLabelError(false);
  };

  const onClickSaveFleetLabel = async () => {
    if (!saveLabel.trim()) {
      setSaveLabelError(true);
      return;
    }
    const findIndex = fleetList.findIndex(
      (item) => item._id === selectedVessels._id
    );

    if (!!saveLabel) {
      const calculatedFleetDetails = fleetList.find(
        (item) => item._id === selectedVessels._id
      );
      const initialFleetDetails = initialFleetList.find(
        (item) => item._id === selectedVessels._id
      );
      const updatedFleetList = [...fleetList];
      updatedFleetList[findIndex] = {
        ...updatedFleetList[findIndex],
        selectedForSave: true,
        saveLabel,
      };
      // setCalculatorData({
      //     ...calculatorData,
      //     fleetList: updatedFleetList
      // })
      // const updatedCalculatorData = {
      //   ...calculatorData,
      //   fleetList: updatedFleetList,
      //   autoSave: true,
      // };
      const clientQueryFinal = {
        ...calculatorData?.clientQuery,
        cargoList: calculatorData?.portOperation,
      };
      const calculatedData = {
        name: saveLabel,
        vessel: selectedVessels,
        clientQuery: clientQueryFinal,
        fleet: initialFleetDetails,
        calculatedFleetResult: calculatedFleetDetails,
      };

      if (selectedVessel === selectedVessels._id) {
        setSelectedVessels({
          ...selectedVessels,
          saveLabel,
        });
      }
      const resultLink = await saveCalculatedCostResult(calculatedData);
      onCloseSaveFleet();
      history.push(`/saved/${resultLink?.data?._id}`);
    }
  };

  const onChangeOrderBy = (order, orderBy) => {
    setOrder(order);
    setOrderBy(orderBy);
  };

  const filteredFleetList = useMemo(() => {
    return stableSort(fleetList, getComparator(order, orderBy));
  }, [fleetList, order, orderBy]);

  const safeFmt = (val, decimals = 0) => {
    const num = Number(val);
    return isNaN(num) ? "0" : num.toFixed(decimals);
  };

  const handleAccordionToggle = (vesselId, vessel) => {
    setExpandedRows((prevState) => {
      const isCurrentlyExpanded = Boolean(prevState[vesselId]);
      const nextExpanded = !isCurrentlyExpanded;
      const newState = { [vesselId]: nextExpanded };

      if (nextExpanded) {
        onClickRowChange(vessel);
      }

      onChangeChartValue(calculatorData, nextExpanded, vessel);
      return newState;
    });
  };

  const autoExpandedRef = useRef(null);
  useEffect(() => {
    if (filteredFleetList?.length !== 1 || !calculatorData) return;
    const vessel = filteredFleetList[0];
    if (!vessel?._id || autoExpandedRef.current === vessel._id) return;
    autoExpandedRef.current = vessel._id;
    if (!expandedRows?.[vessel._id]) handleAccordionToggle(vessel._id, vessel);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredFleetList, calculatorData]);

  const fetchDataForPdf = async () => {
    const id =
      Object.keys(expandedRows).find((k) => expandedRows[k]) ||
      selectedVessels?._id ||
      filteredFleetList?.[0]?._id;
    const { portOperation = [], clientQuery = {} } = calculatorData || {};
    const index = filteredFleetList.findIndex((val) => val._id == id);

    const fleete = index !== -1 ? filteredFleetList[index] : filteredFleetList?.[0];

    const port = portOperation;
    if (!fleete || !port) return {};
    const firstPort = port[0] || {};
    // same "a/b/c" per-loading-port values the Cargo Details panel shows
    const mixOf = (key) =>
      port.filter((p) => p.operation === "Loading").map((p) => p[key] || "0").join("/");
    const sumCargo = (key) =>
      (clientQuery?.cargoList || []).reduce((sum, c) => sum + (Number(c?.[key]) || 0), 0);

    const vessel = JSON.parse(fleete.vessel || "[]") || {};

    const mainVessel = filteredFleetList.flatMap((item) => {
      try {
        return item.vessel ? JSON.parse(item.vessel) : [];
      } catch (error) {
        console.error("Error parsing vessel:", item.vessel, error);
        return [];
      }
    });

    // Construct the PDF data
    const data = {
      Cargo_Details: {
        account: clientQuery.account,
        cargo: clientQuery.name,
        laycanStartDate: clientQuery.laycanStartDate,
        laycanEndDate: clientQuery.laycanEndDate,
        adcom: mixOf("adcom"),
        brokerage: mixOf("brokerage"),
        other: mixOf("other"),
        freightMode: clientQuery.freightMode,
        Cargo_Min: sumCargo("min"),
        Cargo_Max: sumCargo("max"),
        sf_of_cargo: mixOf("stowFactor"),
        Tag1: clientQuery?.Tag1?.name,
        Tag2: clientQuery?.Tag2?.name,
        Tag3: clientQuery?.Tag3?.name,
        Tag4: clientQuery?.Tag4?.name,
      },
      vessel: {
        date_opning: fleete.dateOpen,
        ETA: fleete.portToPortOperationResultMap
          ? fleete.portToPortOperationResultMap[1]?.arrivalTime
          : "",
        vesselPremium: fleete.vesselPremium,
        positionPremium: fleete.positionPremium,
        remark: fleete.remark,
        port: fleete?.port,
        vesselName: vessel.vesselName,
        DWT: vessel.vesselDwt,
        Draft: vessel.vesselDraftS,
        TPC: vessel.vesselTPC,
        grain: vessel.vesselGrainCap,
        built: vessel.vesselBuilt,
        LOA: vessel.vesselLOA,
        Beam: vessel.vesselBeam,
        GRT: vessel.vesselGRT,
        NRT: vessel.vesselNRT,
        light_ship: vessel.vesselLightShip,
        bale_capacity: vessel.vesselBaleCap,
        Gears: vessel.vesselGears,
        Grabs: vessel.vesselGrabs,
        // Constants: vessel.Constants,
        Flag: vessel.vesselFlag,
        MMIS: vessel.vesselMMSI,
        Class: vessel.vesselClass,
        fuel_type: fuelPriceOptions.find((o) => o.value === vessel.fuelType)?.label || "Type-1",
        scrubber: vessel.vesselScrubber || "Yes",
        IMO: vessel.vesselIMO,
        BalComb1: vessel?.vesselBalComb1Selected,
        BalComb2: vessel?.vesselBalComb2Selected,
        BalComb3: vessel?.vesselBalComb3Selected,
        BalComb4: vessel?.vesselBalComb4Selected,
        LadComb1: vessel?.vesselLadComb1Selected,
        LadComb2: vessel?.vesselLadComb2Selected,
        LadComb3: vessel?.vesselLadComb3Selected,
        LadComb4: vessel?.vesselLadComb4Selected,
        Ballast_Sea_Consumptions: {
          col_1: {
            Speed: vessel?.vesselBalSpd1,
            HS: vessel?.vesselBalConsmHS1,
            LS: vessel?.vesselBalConsmLS1,
            MGO: vessel?.vesselBalConsmMGO1,
          },
          col_2: {
            Speed: vessel?.vesselBalSpd2,
            HS: vessel?.vesselBalConsmHS2,
            LS: vessel?.vesselBalConsmLS2,
            MGO: vessel?.vesselBalConsmMGO2,
          },
          col_3: {
            Speed: vessel?.vesselBalSpd3,
            HS: vessel?.vesselBalConsmHS3,
            LS: vessel?.vesselBalConsmLS3,
            MGO: vessel?.vesselBalConsmMGO3,
          },
          col_4: {
            Speed: vessel?.vesselBalSpd4,
            HS: vessel?.vesselBalConsmHS4,
            LS: vessel?.vesselBalConsmLS4,
            MGO: vessel?.vesselBalConsmMGO4,
          },
        },
        Laden_Sea_Consumptions: {
          col_1: {
            Speed: vessel?.vesselLdnSpd1,
            HS: vessel?.vesselLdnConsmHS1,
            LS: vessel?.vesselLdnConsmLS1,
            MGO: vessel?.vesselLdnConsmMGO1,
          },
          col_2: {
            Speed: vessel?.vesselLdnSpd2,
            HS: vessel?.vesselLdnConsmHS2,
            LS: vessel?.vesselLdnConsmLS2,
            MGO: vessel?.vesselLdnConsmMGO2,
          },
          col_3: {
            Speed: vessel?.vesselLdnSpd3,
            HS: vessel?.vesselLdnConsmHS3,
            LS: vessel?.vesselLdnConsmLS3,
            MGO: vessel?.vesselLdnConsmMGO3,
          },
          col_4: {
            Speed: vessel?.vesselLdnSpd4,
            HS: vessel?.vesselLdnConsmHS4,
            LS: vessel?.vesselLdnConsmLS4,
            MGO: vessel?.vesselLdnConsmMGO4,
          },
        },
        Port_Consumptions: {
          Idle: {
            HS: vessel?.vesselPIdleConsmHS,
            LS: vessel?.vesselPIdleConsmLS,
            MGO: vessel?.vesselPIdleConsmMGO,
          },
          Loading: {
            HS: vessel?.vesselPLdgConsmHS,
            LS: vessel?.vesselPLdgConsmLS,
            MGO: vessel?.vesselPLdgConsmMGO,
          },
          Disch: {
            HS: vessel?.vesselPDischConsmHS,
            LS: vessel?.vesselPDischConsmLS,
            MGO: vessel?.vesselPDischConsmMGO,
          },
          Extra: {
            HS: vessel?.vesselVExtraConsmHS,
            LS: vessel?.vesselVExtraConsmLS,
            MGO: vessel?.vesselVExtraConsmMGO,
          },
        },
      },
      Margin_and_Allowances: {
        DWF: firstPort?.dwf,
        Perf_Factor: firstPort?.cargoDetails?.speedFactor,
        speedReduce: firstPort?.cargoDetails?.speedReduce,
        bnkrFactor: firstPort?.cargoDetails?.bnkrFactor,
        extraExpense: fleete.extraExpense,
        constants: fleete.constants,
        fuelCalculationMethod: clientQuery.fuelCalculationMethod || "DEFAULT",
        tcAdcom: selectedVessels?.tcAdcom ?? fleete?.tcAdcom,
        brokerage: selectedVessels?.brokerage ?? fleete?.brokerage,
        Bunker_Fuel: {
          Main: selectedVessels?.bnkFuelMain,
          ECA: selectedVessels?.bnkFuelEca,
          MGO: selectedVessels?.bnkFuelMgo,
        },
        Fuel_Price: {
          fuel_type: clientQuery.fuelType,
          Normal: clientQuery.hsFuelPriceType0,
          ECA: clientQuery.lsFuelPriceType0,
          MGO: clientQuery.mgoFuelPriceType0,
        },
      },

      Freight_and_Result: {
        Freight_Rate: clientQuery.freightIdea,
        tcEq: fleete.tcEq,
        gbb: fleete.gbb,
        hirePerDay: fleete.hirePerDay,
        hireGbb: fleete.hireGbb,
        profitPerDay: fleete.profitPerDay,
        profitPerDayGBB: fleete.profitPerDayGBB,
        Misc_Revenue: clientQuery.miscRevenue,
        CVE: clientQuery.cve,
        insurance: clientQuery.insurance,
        hireSurvey: clientQuery.hireSurvey,
        canalExpenses: clientQuery.canalExpenses,
        additionalPremium: clientQuery.additionalPremium,
        ilohc: clientQuery.ilohc,
        miscExp: clientQuery.miscExp,
        manoevringExp: clientQuery.manoevringExp,
      },
      result: {
        frtCost: fleete.frtCost,
        profitPmt: fleete.profitPmt,
        profitNet: fleete.profitNet,
        netFrtRevenue: fleete.netFrtRevenue,
        hireExpense: fleete.hireExpense,
        fuelExpense: fleete.fuelExpense,
        otherExpense: fleete.otherExpense,
        hsQuantity: fleete.hsQuantity,
        lsQuantity: fleete.lsQuantity,
        mgoQuantity: fleete.mgoQuantity,
        voyageDuration: fleete.voyageDuration,
        portStayTotal: fleete.portStayTotal,
        stowage: fleete.stowage,
        fuelSettlementProfit: fleete.fuelSettlementProfit,
      },
      add_operations: port.map((port) => ({
        operation: port?.operation,
        lbmarker: port?.lbmarker,
        Port: port?.port,
        distNormal: port?.cargoDetails?.distNormal,
        distEca: port?.cargoDetails?.distEca,
        dwf: port?.dwf,
        speedNormal: port?.speedNormal,
        speedECA: port?.speedECA,
        cargoTx: port?.cargoTx,
        rate: port?.rate,
        terms: port?.terms,
        factor: port?.factor,
        turnTime: port?.turnTime,
        extraDays: port?.extraDays,
        portExp: port?.portExp,
        portStay: port?.portStay,
        loadline: port?.loadline,
        draftRes: port?.draftRes,
        waterDensity: port?.waterDensity,
        supply: port?.supply,
        Port_emission: port?.sulfur,
      })),
      otherTables: (() =>
        filteredFleetList.map((fleetItem, i) => {
          const vessel = mainVessel[i];
          // const portList = port[i];
          const formatNumber = (value, decimals = 2) =>
            value ? Number(value).toFixed(decimals) : 0;

          return {
            _id: fleetItem._id,
            frtCost: port?.frtCost,
            vessel_name: vessel?.vesselName || "",
            DWT: vessel?.vesselDwt || 0,
            VesselPremium: fleetItem?.vesselPremium || 0,
            positionPremium: fleetItem?.positionPremium || 0,
            remark: fleetItem?.remark || "",
            port: fleetItem?.port || "",
            ETA:
              fleetItem?.portToPortOperationResultMap?.[1]?.arrivalTime || "",
            tcEq: formatNumber(fleetItem?.tcEq),
            gbb: formatNumber(fleetItem?.gbb),
            hirePerDay: formatNumber(fleetItem?.hirePerDay),
            hireGbb: formatNumber(fleetItem?.hireGbb),
            profit: formatNumber(fleetItem?.profitNet),
            loadability: formatNumber(fleetItem?.loadability),
            dateOpen: fleetItem?.dateOpen || "",
          };
        }))(),
    };

    return data;
  };

  const prevPdfDataRef = useRef("");

  const onDownloadPdf = async () => {
    const generatedData = await fetchDataForPdf();
    const stringifiedData = JSON.stringify(generatedData || {});
    if (prevPdfDataRef.current !== stringifiedData) {
      prevPdfDataRef.current = stringifiedData;
      setPdfData(generatedData);
    }
  };

  useEffect(() => {
    onDownloadPdf();
  }, [calculatorData, expandedRows, orderBy, order, filteredFleetList, selectedVessels]);

  return (
    <div>
      <div className="port-operation-buttons">
        <div>
          {/* <button
            className="px-3 py-1 text-center bg-neutrals9 hover:bg-neutrals7 border border-neutrals6 text-neutrals4 rounded-md text-sm flex items-center gap-1 mb-2"
            onClick={onClickAddFleet}
          >
            + Add Vessel
          </button> */}
          <div className="flex">
            {/* {!isFromCargoAnalysis && (
              <Link
                className="px-3 py-1 text-center add-vessel-button border border-neutrals6 rounded-md text-sm flex items-center gap-1 mb-2"
                href="/vesselManager"
              >
                + Add Vessel
              </Link>
            )} */}
            {/* <PDFDownloadLink
              document={<PdfDataComponent data={data} />}
              fileName={`${Date.now()}.pdf`} // Corrected this line
            >
              <div className="px-3 py-1 text-center bg-[#313C4C] hover:bg-[#06195f] hover:underline border border-neutrals6 text-white rounded-md text-sm flex items-center gap-1 ms-3">
                Dowload PDF
              </div>
            </PDFDownloadLink> */}
          </div>
        </div>
        {/* <div className="vessel-extra-actions">
          <div className="extra-actions-div">
            <span>TC Adcom %:</span>
            <input
              type="number"
              name="tcAdcom"
              value={tcAdcom}
              onKeyDown={handleKeyDown}
              onChange={onChangeClientQuery}
            />
          </div> */}
        {/* <div className="extra-actions-div">
            <span>Delivery Terms</span>
            <select
              name="deliveryTerms"
              value={deliveryTerms}
              onChange={onChangeClientQuery}
            >
              <option value="DLOSP">DLOSP</option>
              <option value="AFSPS">AFSPS</option>
            </select>
          </div> */}
        {/* </div> */}
      </div>
      {/* <div style={{ width: '100%' }}> */}

      {/* </div> */}
      <TableContainer component={Paper} className="vessel-selection-table scroll-thin" data-spotlight="matrix-vessel-table">
        <Table>
          <TableHead>
            <TableRow>
              {vesselTableHeading.map((item) => {
                if (isFromCargoAnalysis && item?.title === "Actions") {
                  return null;
                }
                const align = item.align || (item.showOrder ? "right" : "left");
                const isRight = align === "right";
                const isCenter = align === "center";

                return (
                  <TableCell
                    key={item._id || item.id}
                    align={align}
                    style={{
                      textAlign: align,
                      ...(item.width ? { width: item.width, minWidth: item.width } : {}),
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: isRight
                          ? "flex-end"
                          : isCenter
                            ? "center"
                            : "flex-start",
                        gap: 2,
                      }}
                    >
                      <span>{item.title}</span>
                      {item.showOrder ? (
                        order === "desc" && item.id === orderBy ? (
                          <ArrowDownwardIcon
                            className="table-sort-arrow active-arrow"
                            onClick={() => onChangeOrderBy("asc", item.id)}
                          />
                        ) : order === "asc" && item.id === orderBy ? (
                          <ArrowUpwardIcon
                            className="table-sort-arrow active-arrow"
                            onClick={() => onChangeOrderBy("desc", item.id)}
                          />
                        ) : order === "desc" && item.id !== orderBy ? (
                          <ArrowDownwardIcon
                            className="table-sort-arrow"
                            onClick={() => onChangeOrderBy("asc", item.id)}
                          />
                        ) : order === "asc" && item.id !== orderBy ? (
                          <ArrowUpwardIcon
                            className="table-sort-arrow"
                            onClick={() => onChangeOrderBy("desc", item.id)}
                          />
                        ) : null
                      ) : null}
                    </div>
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.isArray(filteredFleetList) && filteredFleetList.length ? (
              filteredFleetList.map((vessel) => {
                const {
                  _id,
                  vesselName = "",
                  dateOpen = "",
                  port = "",
                  gbb = 0,
                  hireGbb = 0,
                  hirePerDay = 0,
                  remark = "",
                  tcEq = 0,
                  portToPortOperationResultMap = {},
                  frtCost = 0,
                  profitNet = 0,
                  loadability = 0,
                  vesselPremium = 0,
                  positionPremium = 0,
                  vessel: fleetVesselData,
                  splitHire = "",
                  isReferenceVessel = false,
                  saveLabel = "",
                } = vessel || {};

                const { vesselDwt = 0 } = JSON.parse(fleetVesselData) || "";
                const isSelected = selectedVessels._id === _id || false;
                const arrivalTime =
                  (portToPortOperationResultMap &&
                    portToPortOperationResultMap[1] &&
                    portToPortOperationResultMap[1].arrivalTime) ||
                  "";
                const isExpanded = expandedRows[_id];
                const hasTrueValue = expandedRows
                  ? Object.values(expandedRows)?.some((value) => value === true)
                  : false;
                return (
                  <>
                    {hasTrueValue ? (
                      isSelected && (
                        <TableRow
                          key={_id}
                          data-spotlight="matrix-vessel-row"
                          aria-expanded={Boolean(isExpanded)}
                          onClick={() => {
                            handleAccordionToggle(vessel._id, vessel);
                          }}
                          className={
                            isSelected
                              ? "selected-fleet-row"
                              : `non-selected-fleet-row ${isReferenceVessel ? "reference-fleet" : ""
                              }`
                          }
                        >
                          <TableCell style={{ width: 26, minWidth: 26, padding: "0 2px", textAlign: "center", cursor: "pointer", position: "relative" }}>
                            {isSelected ? (
                              <span className="vessel-row-indicator selected" />
                            ) : isReferenceVessel ? (
                              <span className="vessel-row-indicator reference" />
                            ) : null}
                            <ExpandMoreIcon
                              style={{
                                fontSize: "18px",
                                color: isSelected ? "#313C4C" : "#64748b",
                                transform: isExpanded
                                  ? "rotate(180deg)"
                                  : "rotate(0deg)",
                                transition: "transform 0.2s ease",
                              }}
                            />
                          </TableCell>
                          <TableCell style={{ color: "#0f172a" }}>
                            {JSON.parse(vessel?.vessel)?.vesselName}
                          </TableCell>
                          <TableCell align="right" style={{ width: 55, minWidth: 55 }}>
                            {vesselDwt}
                          </TableCell>
                          <TableCell>{port}</TableCell>
                          <TableCell className="!p-0" style={{ width: 120, minWidth: 120, maxWidth: 120 }} onClick={(e) => e.stopPropagation()}>
                            <MuiPickersUtilsProvider
                              utils={MomentUtils}
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                              }}
                            >
                              <DateTimePicker
                                inputVariant="outlined"
                                size="small"
                                value={dateOpen || null}
                                format="DD/MMM/yyyy HH:mm"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                }}
                                onChange={(date) =>
                                  onChangeHandler(vessel._id, "dateOpen", date)
                                }
                              />
                            </MuiPickersUtilsProvider>
                          </TableCell>
                          <TableCell align="right" style={{ width: 65, minWidth: 65 }}>
                            {safeFmt(tcEq, 0)}
                          </TableCell>
                          <TableCell className="!p-0" style={{ width: 50, minWidth: 50 }}>
                            <input
                              type="number"
                              className="vessel-list-editable-input text-right"
                              value={gbb || ""}
                              placeholder="0"
                              onKeyDown={handleKeyDown}
                              onClick={(e) => e.stopPropagation()}
                              onChange={(e) =>
                                onChangeHandler(
                                  vessel._id,
                                  "gbb",
                                  e.target.value
                                )
                              }
                            />
                          </TableCell>
                          <TableCell className="!p-0" style={{ width: 85, minWidth: 85 }}>
                            <div className="relative flex items-center h-full w-full">
                              <input
                                type="number"
                                className="vessel-list-editable-input text-right split-hire-input"
                                value={hirePerDay || ""}
                                onKeyDown={handleKeyDown}
                                placeholder="0"
                                onClick={(e) => e.stopPropagation()}
                                onChange={(e) =>
                                  onChangeHandler(
                                    vessel._id,
                                    "hirePerDay",
                                    e.target.value
                                  )
                                }
                              />
                              <span
                                className={`split-hire-dot ${splitHire ? "red" : "green"
                                  }`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  openSplitHireModal(vessel);
                                }}
                              >
                                &bull;
                              </span>
                            </div>
                          </TableCell>
                          <TableCell className="!p-0" style={{ width: 50, minWidth: 50 }}>
                            <input
                              type="number"
                              className="vessel-list-editable-input text-right"
                              value={hireGbb || ""}
                              onKeyDown={handleKeyDown}
                              placeholder="0"
                              onClick={(e) => e.stopPropagation()}
                              onChange={(e) =>
                                onChangeHandler(
                                  vessel._id,
                                  "hireGbb",
                                  e.target.value
                                )
                              }
                            />
                          </TableCell>
                          <TableCell align="right" style={{ width: 80, minWidth: 80 }}>
                            {safeFmt(frtCost, 3)}
                          </TableCell>
                          <TableCell align="right" style={{ width: 75, minWidth: 75 }}>
                            {safeFmt(profitNet, 0)}
                          </TableCell>
                          <TableCell align="right" style={{ width: 65, minWidth: 65 }}>
                            {safeFmt(loadability, 0)}
                          </TableCell>
                          <TableCell style={{ width: 105, minWidth: 105, maxWidth: 105 }}>
                            {arrivalTime
                              ? moment(arrivalTime).format("DD/MMM/yyyy HH:mm")
                              : ""}
                          </TableCell>
                          <TableCell align="right" style={{ width: 58, minWidth: 58 }}>
                            {safeFmt(vesselPremium, 0)}
                          </TableCell>
                          <TableCell align="right" style={{ width: 62, minWidth: 62 }}>
                            {safeFmt(positionPremium, 0)}
                          </TableCell>
                          <TableCell className="!p-0" style={{ width: 90, minWidth: 90 }}>
                            <textarea
                              value={remark}
                              placeholder="Remarks..."
                              onClick={(e) => e.stopPropagation()}
                              onChange={(e) =>
                                onChangeHandler(
                                  vessel._id,
                                  "remark",
                                  e.target.value
                                )
                              }
                            />
                          </TableCell>
                          {!isFromCargoAnalysis && (
                            <TableCell style={{ width: 58, minWidth: 58, padding: "0 2px", textAlign: "center" }} onClick={(e) => e.stopPropagation()}>
                              <div className="flex items-center justify-center gap-1">
                                <Tooltip title={<span className="text-xs">Delete</span>}>
                                  <DeleteIcon
                                    style={{
                                      fontSize: "17px",
                                      color: "#ef4444",
                                      cursor: "pointer",
                                    }}
                                    className="hover:!text-rose-700 transition-colors"
                                    onClick={(e) => {
                                      setDeleteId(_id);
                                      setShowConfrim(true);
                                    }}
                                  />
                                </Tooltip>
                                <Tooltip title={<span className="text-xs">{isReferenceVessel ? "Unmark Reference" : "Mark as Reference"}</span>}>
                                  <div className="flex items-center justify-center shrink-0">
                                    <img
                                      src={isReferenceVessel ? pinIconRed : pinIconBlack}
                                      style={{
                                        width: "14px",
                                        height: "14px",
                                        minWidth: "14px",
                                        minHeight: "14px",
                                        maxWidth: "14px",
                                        maxHeight: "14px",
                                        objectFit: "contain",
                                        display: "block",
                                        cursor: "pointer"
                                      }}
                                      className="opacity-70 hover:opacity-100 transition-opacity shrink-0"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        onClickReferencePin(vessel);
                                      }}
                                      alt={isReferenceVessel ? "Unmark reference" : "Mark as reference"}
                                    />
                                  </div>
                                </Tooltip>
                                <Tooltip title={<span className="text-xs">Save as Voyage</span>}>
                                  <ShareIcon
                                    style={{
                                      fontSize: "17px",
                                      color: "#94a3b8",
                                      cursor: "pointer",
                                    }}
                                    className="hover:!text-emerald-600 transition-colors"
                                    onClick={() =>
                                      onClickSaveFleet(_id, saveLabel, vessel)
                                    }
                                  />
                                </Tooltip>
                              </div>
                            </TableCell>
                          )}
                        </TableRow>
                      )
                    ) : (
                      <TableRow
                        key={_id}
                        data-spotlight="matrix-vessel-row"
                        aria-expanded={Boolean(isExpanded)}
                        onClick={() => {
                          handleAccordionToggle(vessel._id, vessel);
                        }}
                        className={
                          isSelected
                            ? "selected-fleet-row"
                            : `non-selected-fleet-row ${isReferenceVessel ? "reference-fleet" : ""
                            }`
                        }
                      >
                        <TableCell style={{ width: 26, minWidth: 26, padding: "0 2px", textAlign: "center", cursor: "pointer", position: "relative" }}>
                          {isSelected ? (
                            <span className="vessel-row-indicator selected" />
                          ) : isReferenceVessel ? (
                            <span className="vessel-row-indicator reference" />
                          ) : null}
                          <ExpandMoreIcon
                            style={{
                              fontSize: "18px",
                              color: isSelected ? "#313C4C" : "#64748b",
                              transform: isExpanded
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                              transition: "transform 0.2s ease",
                            }}
                          />
                        </TableCell>
                        <TableCell style={{ color: "#0f172a" }}>
                          {JSON.parse(vessel?.vessel)?.vesselName}
                        </TableCell>
                        <TableCell align="right" style={{ width: 55, minWidth: 55 }}>
                          {vesselDwt}
                        </TableCell>
                        <TableCell>{port}</TableCell>
                        <TableCell className="!p-0" style={{ width: 120, minWidth: 120, maxWidth: 120 }} onClick={(e) => e.stopPropagation()}>
                          <MuiPickersUtilsProvider
                            utils={MomentUtils}
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                            }}
                          >
                            <DateTimePicker
                              inputVariant="outlined"
                              size="small"
                              value={dateOpen || null}
                              format="DD/MMM/yyyy HH:mm"
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                              }}
                              onChange={(date) =>
                                onChangeHandler(vessel._id, "dateOpen", date)
                              }
                            />
                          </MuiPickersUtilsProvider>
                        </TableCell>
                        <TableCell align="right" style={{ width: 65, minWidth: 65 }}>
                          {safeFmt(tcEq, 0)}
                        </TableCell>
                        <TableCell className="!p-0" style={{ width: 50, minWidth: 50 }}>
                          <input
                            type="number"
                            className="vessel-list-editable-input text-right"
                            value={gbb || ""}
                            placeholder="0"
                            onKeyDown={handleKeyDown}
                            onClick={(e) => e.stopPropagation()}
                            onChange={(e) =>
                              onChangeHandler(vessel._id, "gbb", e.target.value)
                            }
                          />
                        </TableCell>
                        <TableCell className="!p-0" style={{ width: 85, minWidth: 85 }}>
                          <div className="relative flex items-center h-full w-full">
                            <input
                              type="number"
                              className="vessel-list-editable-input text-right split-hire-input"
                              value={hirePerDay || ""}
                              onKeyDown={handleKeyDown}
                              placeholder="0"
                              onClick={(e) => e.stopPropagation()}
                              onChange={(e) =>
                                onChangeHandler(
                                  vessel._id,
                                  "hirePerDay",
                                  e.target.value
                                )
                              }
                            />
                            <span
                              className={`split-hire-dot ${splitHire ? "red" : "green"
                                }`}
                              onClick={(e) => {
                                e.stopPropagation();
                                openSplitHireModal(vessel);
                              }}
                            >
                              &bull;
                            </span>
                          </div>
                        </TableCell>
                        <TableCell className="!p-0" style={{ width: 50, minWidth: 50 }}>
                          <input
                            type="number"
                            className="vessel-list-editable-input text-right"
                            value={hireGbb || ""}
                            onKeyDown={handleKeyDown}
                            placeholder="0"
                            onClick={(e) => e.stopPropagation()}
                            onChange={(e) =>
                              onChangeHandler(
                                vessel._id,
                                "hireGbb",
                                e.target.value
                              )
                            }
                          />
                        </TableCell>
                        <TableCell align="right" style={{ width: 80, minWidth: 80 }}>
                          {safeFmt(frtCost, 3)}
                        </TableCell>
                        <TableCell align="right" style={{ width: 75, minWidth: 75 }}>
                          {safeFmt(profitNet, 0)}
                        </TableCell>
                        <TableCell align="right" style={{ width: 65, minWidth: 65 }}>
                          {safeFmt(loadability, 0)}
                        </TableCell>
                        <TableCell style={{ width: 105, minWidth: 105, maxWidth: 105 }}>
                          {arrivalTime
                            ? moment(arrivalTime).format("DD/MMM/yyyy HH:mm")
                            : ""}
                        </TableCell>
                        <TableCell align="right" style={{ width: 58, minWidth: 58 }}>
                          {safeFmt(vesselPremium, 0)}
                        </TableCell>
                        <TableCell align="right" style={{ width: 62, minWidth: 62 }}>
                          {safeFmt(positionPremium, 0)}
                        </TableCell>
                        <TableCell className="!p-0" style={{ width: 90, minWidth: 90 }}>
                          <textarea
                            value={remark}
                            placeholder="Remarks..."
                            onClick={(e) => e.stopPropagation()}
                            onChange={(e) =>
                              onChangeHandler(
                                vessel._id,
                                "remark",
                                e.target.value
                              )
                            }
                          />
                        </TableCell>
                        {!isFromCargoAnalysis && (
                          <TableCell style={{ width: 58, minWidth: 58, padding: "0 2px", textAlign: "center" }} onClick={(e) => e.stopPropagation()}>
                            <div className="flex items-center justify-center gap-1">
                              <Tooltip title={<span className="text-xs">
                                Delete Fleet
                              </span>}>
                                <DeleteIcon
                                  style={{
                                    fontSize: "17px",
                                    color: "#ef4444",
                                    cursor: "pointer",
                                  }}
                                  className="hover:!text-rose-700 transition-colors"
                                  onClick={(e) => {
                                    setDeleteId(_id);
                                    setShowConfrim(true);
                                  }}
                                />
                              </Tooltip>
                              <Tooltip title={<span className="text-xs">
                                {isReferenceVessel ? "Unmark Reference" : "Mark as Reference"}
                              </span>}>
                                <div className="flex items-center justify-center shrink-0">
                                  <img
                                    src={isReferenceVessel ? pinIconRed : pinIconBlack}
                                    style={{
                                      width: "14px",
                                      height: "14px",
                                      minWidth: "14px",
                                      minHeight: "14px",
                                      maxWidth: "14px",
                                      maxHeight: "14px",
                                      objectFit: "contain",
                                      display: "block",
                                      cursor: "pointer"
                                    }}
                                    className="opacity-70 hover:opacity-100 transition-opacity shrink-0"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      onClickReferencePin(vessel);
                                    }}
                                    alt={isReferenceVessel ? "Unmark reference" : "Mark as reference"}
                                  />
                                </div>
                              </Tooltip>
                              <Tooltip title={<span className="text-xs">
                                Save as Voyage
                              </span>}>
                                <ShareIcon
                                  style={{
                                    fontSize: "17px",
                                    color: "#94a3b8",
                                    cursor: "pointer",
                                  }}
                                  className="hover:!text-emerald-600 transition-colors"
                                  onClick={() =>
                                    onClickSaveFleet(_id, saveLabel, vessel)
                                  }
                                />
                              </Tooltip>
                            </div>
                          </TableCell>
                        )}
                      </TableRow>
                    )}
                  </>
                );
              })
            ) : loader ? (<TableRow>
              <TableCell colSpan={11} align="center" className="!bg-white">
                <Box display="flex" justifyContent="center" alignItems="center" height="440px">
                </Box>
              </TableCell>
            </TableRow>) : (
              <TableRow>
                <TableCell colSpan="18" align="center" className="!bg-white">
                  No Vessel Found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {/* Expanded Accordion details section outside the table's scroll area */}
      {Array.isArray(filteredFleetList) &&
        filteredFleetList.map((vessel) => {
          const { _id, tcAdcom } = vessel || {};
          const isExpanded = expandedRows[_id];
          if (!isExpanded) return null;
          return (
            <div key={`expanded-${_id}`} className="mt-3 mb-0">
              <Accordion
                className="accordian-background"
                expanded={!!isExpanded}
                onChange={() => handleAccordionToggle(_id)}
                style={{ borderRadius: "4px", border: "1px solid #cbd5e1", margin: 0 }}
              >
                <AccordionDetails style={{ padding: 0 }}>
                  <Typography style={{ width: "100%", margin: 0, overflow: "hidden" }} component="div">
                    <CalculatorMain
                      disableEdit={disableEdit}
                      cargoTabs={cargoTabs}
                      calculatorData={calculatorData}
                      setLoader={setLoader}
                      getInitalQueryAndFleetData={getInitalQueryAndFleetData}
                      setSelectedVessels={setSelectedVessels}
                      selectedVessels={selectedVessels}
                      setCalculatorData={setCalculatorData}
                      onChangeHandler={onChangeSelectedVessel}
                      fleetCheckbox={fleetCheckbox}
                      setFleetCheckbox={setFleetCheckbox}
                      onChangeSelectedVessel={onChangeSelectedVessel}
                      setMarginModal={setMarginModal}
                      syncBunker={syncBunker}
                      setSyncBunker={setSyncBunker}
                      setSupplyModal={setSupplyModal}
                      onChangeSyncBunker={onChangeSyncBunker}
                      isOverride={isOverride}
                      onFetchPortOperationDistance={onFetchPortOperationDistance}
                      openSplitHireModal={openSplitHireModal}
                      calculationErrors={calculationErrors}
                      marginModal={marginModal}
                      onChangePortOperations={onChangePortOperations}
                      onAddOperations={onAddOperations}
                      onDeleteOperations={onDeleteOperations}
                      supplyModal={supplyModal}
                      fetchPortDistance={fetchPortDistance}
                      openAddOperation={openAddOperation}
                      setOpenAddOperation={setOpenAddOperation}
                      setOpenAddOperationindex={setOpenAddOperationindex}
                      onChangePortCanalInQueryState={onChangePortCanalInQueryState}
                      setIsOverride={setIsOverride}
                      hideOrder={hideOrder}
                      setHideOrder={setHideOrder}
                      hideCalculator={hideCalculator}
                      sendCalculationRequest={sendCalculationRequest}
                      getCurrentResult={getCurrentResult}
                      isFromCargoAnalysis={isFromCargoAnalysis}
                      onChangeChartValue={onChangeChartValue}
                      setShowExpensesModal={setShowExpensesModal}
                      onChangeClientQuery={onChangeClientQuery}
                      tcAdcom={tcAdcom}
                      onReorder={onReorder}
                      onPortChange={onPortChange}
                    />
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
          );
        })}
      <CustomShowModal
        open={addFleetModal}
        disableClose
        handleClose={onClickAddFleet}
        maxWidth="lg"
        title="Add Fleet"
      >
        <AddFleetModal
          calculatorData={calculatorData}
          setCalculatorData={setCalculatorData}
          addFleetsArray={addFleetsArray}
          setAddFleetsArray={setAddFleetsArray}
          onChangeNewFleetsValue={onChangeNewFleetsValue}
          setLoader={setLoader}
          setAddFleetModal={setAddFleetModal}
          sendCalculationRequest={sendCalculationRequest}
          getInitalQueryAndFleetData={getInitalQueryAndFleetData}
          onClickAddFleet={onClickAddFleet}
        />
      </CustomShowModal>

      <CustomShowModal
        open={splitHireModal}
        handleClose={() => setSplitHireModal(false)}
        maxWidth="xs"
        title="Split Hire"
      >
        <SplitHireModal
          addNewSplitHire={addNewSplitHire}
          selectedSplitHire={selectedSplitHire}
          onChangeSplitHire={onChangeSplitHire}
        />
      </CustomShowModal>

      <CustomShowModal
        open={showExpensesModal}
        handleClose={() => setShowExpensesModal(false)}
        maxWidth="xs"
        title="Expenses Per Day"
      >
        <DailyExpensesModal
          calculatorData={calculatorData}
          setCalculatorData={setCalculatorData}
          dailyExpenses={calculatorData?.clientQuery?.dailyExpenses}
          open={showExpensesModal}
        />
      </CustomShowModal>

      <CustomAddModal
        open={saveModal}
        handleClose={onCloseSaveFleet}
        onSubmitConfirm={onClickSaveFleetLabel}
        maxWidth="xs"
        saveLabel="Save"
        title="Save Voyage"
      >
        <SaveVesselLabel
          value={saveLabel}
          onChange={(e) => {
            setSaveLabel(e.target.value);
            setSaveLabelError(false);
          }}
          error={saveLabelError}
        />
      </CustomAddModal>

      <ConfirmModal
        open={Boolean(referenceCandidate)}
        title={referenceCandidate?.isReferenceVessel ? "Unmark reference vessel?" : "Mark as reference vessel?"}
        message={referenceCandidate?.isReferenceVessel ? (
          <span className="block text-left">
            <span className="block mb-2">
              This removes the marked reference and recalculates the Matrix immediately.
            </span>
            <span className="block">
              The calculation sends no marked reference, so Vessel Premium and Position Premium may change. This calculation does not save the results; Calculate &amp; Save saves only the selected vessel.
            </span>
          </span>
        ) : (
          <span className="block text-left">
            <span className="block mb-2">
              This vessel becomes the comparison reference, replacing any currently marked vessel. Confirming recalculates the Matrix immediately.
            </span>
            <span className="block mb-2">
              Vessel Premium and Position Premium can change on other rows, along with other returned calculation values.
            </span>
            <span className="block">
              The calculation service determines the split between the two premium columns. This calculation does not save the results; Calculate &amp; Save saves only the selected vessel.
            </span>
          </span>
        )}
        handleClose={() => setReferenceCandidate(null)}
        onSubmitConfirm={onConfirmReferencePin}
        confirmText={referenceCandidate?.isReferenceVessel ? "Unmark Reference" : "Mark Reference"}
        cancelText="Cancel"
      />

      <ConfirmModal
        open={showConfrim}
        message="Are you sure you want to delete this Vessel?"
        handleClose={() => setShowConfrim(false)}
        onSubmitConfirm={onClickDeleleButton}
        type="warning"
        note="This action cannot be undone."
        confirmText="Confirm"
        cancelText="Cancel"
      />
    </div>
  );
}

export default memo(VesselSelection);
